import customNumber from './customNumberFormatter';

module.exports = {
    shortenLargeNumber(num, digits) {
        const units = ['M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
        let decimal;

        for (let i = units.length - 1; i >= 0; i -= 1) {
            decimal = Math.pow(1000000, i + 1);
            if (num <= -decimal || num >= decimal) {
                return +(num / decimal).toFixed(digits) + units[i];
            }
        }

        return customNumber.fixThousands(num);
    },
};



/** WEBPACK FOOTER **
 ** ./client/lib/numberFormatter.js
 **/